export enum Feature {
  ActionableTaskView = 'Actionable Task View',
  BoardsPageTemplatePicker = 'Boards Page Template Picker',
  TeamTemplatePicker = 'Team Template Picker',
  TemplatePicker = 'Template Picker',
  TeamProfile = 'Team Profile Header',
  TeamEditAvatar = 'Team Edit Avatar',
  Moonshot = 'moonshot',
  FreeTrialExistingTeam = 'Free Trial Existing Team',
  CardDetailDialog = 'Card Detail Dialog',
  CovidChurn = 'Covid Churn',
  UpgradePrompt = 'Upgrade Prompt',
  WorkspacesPreamble = 'Workspaces Preamble',
  TemplateTips = 'Template Tips',
  TeamOnboarding = 'Team Onboarding',
  TemplatesGallery = 'Templates Gallery',
  TemplatesInCreateFlow = 'Templates In Create Flow',
  CardFrontLinks = 'Card Front Links',
  UndoAction = 'Undo Action',
  PluginPermissions = 'Plugin Permissions',
  Madlibs = 'Madlibs',
  JswTouchpoints = 'Jsw Touchpoints',
  FreeTeamOnboarding = 'Free Team Onboarding',
  ButlerOnBoards = 'Butler on Boards',
  NuSkuBillingView = 'NuSku Billing View',
  WorkspaceNavigation = 'Workspace Navigation',
  BlockTeamlessBoards = 'Block Teamless Boards',
  TimelineView = 'Timeline View',
  MigrationWizard = 'Migration Wizard',
}
